export const SET_IS_AUTHORIZED = '@ADMIN/SET_IS_AUTHORIZED'
export const SET_PASSWORD_CHANGED = '@ADMIN/SET_PASSWORD_CHANGED'

export const REQUEST_LOGIN = '@ADMIN/REQUEST_LOGIN'
export const REQUEST_SIGNUP = '@ADMIN/REQUEST_SIGNUP'
export const REQUEST_LOGIN_OR_SIGNUP_SUCCESS = '@ADMIN/REQUEST_LOGIN_OR_SIGNUP_SUCCESS'
export const REQUEST_LOGIN_OR_SIGNUP_FAILURE = '@ADMIN/REQUEST_LOGIN_OR_SIGNUP_FAILURE'
export const REQUEST_CHANGE_PASSWORD = '@ADMIN/REQUEST_CHANGE_PASSWORD'

export const SIGN_OUT = '@ADMIN/SIGN_OUT'

export const ORIGIN_NOW = '@ADMIN/ORIGIN_NOW'
